import "./index.css"; // we'll add styles here

const Maintenance = () => {
  return (
    <div className="maintenance-container">
      {/* Desktop Image */}
      <img
        src="/assets/images/maintenance/blue-dart-maintenance.png"
        alt="Maintenance"
        className="maintenance-desktop"
      />

      {/* Mobile Image */}
      <img
        src="/assets/images/maintenance/blue-dart-maintenance-mobile.png"
        alt="Maintenance Mobile"
        className="maintenance-mobile"
      />
    </div>
  );
};

export default Maintenance;
